import { useContext } from 'react'
import classnames from 'classnames'
import { Chevron } from './Chevron'
import { useSelector } from 'react-redux'
import { Text, Button } from '../../../../../..'
import { defineMessages, useIntl } from 'react-intl'
import { NO_OP_MORE_BUTTON } from '../../../../../../../constants/listings'
import { useListingSearchContext } from '../../../../../../../context/listingSearch'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'
import { selectSavedSearches } from '../../../../../../../store/selectors/savedSearches'

import styles from './SearchResult.module.scss'

export const MSG = defineMessages({
  more: {
    id: 'HomeSearch.savedSearches.more',
    defaultMessage: '{num} More',
  },
})

export interface SearchResultLocation {
  name: string
}

export interface SearchResult {
  id: string
  name?: string
  displayName: string
  maxPriceCents?: number
  minPriceCents?: number
  minBedroomsCount?: number
  location?: SearchResultLocation
}

export interface SearchResultProps {
  type: string
  index: number
  result: SearchResult
  isLastResult: boolean
  indexOfResultInFlattenResults: number
}

export const SearchResult = ({
  type,
  index,
  result,
  isLastResult,
  indexOfResultInFlattenResults,
}: SearchResultProps) => {
  const {
    selectedIndex,
    handleKeyDown,
    handleOnClick,
    handleOnTouchStart,
    numberOfSavedSearchesToDisplay,
  } = useListingSearchContext()

  const intl = useIntl()
  const { ampli } = useContext(AmplitudeContext)
  const isMoreButton = result.id === NO_OP_MORE_BUTTON
  const savedSearches = useSelector(selectSavedSearches)
  const focused = indexOfResultInFlattenResults === selectedIndex

  const handleClick = () => {
    ampli?.searchCompleted()
    handleOnClick(type, index)
  }

  if (isMoreButton && savedSearches?.length) {
    return (
      <Button
        minimal
        fullWidth
        tabIndex={-1}
        onClick={handleClick}
        aria-selected={focused}
        onKeyDown={handleKeyDown}
        className={classnames(styles.more, focused && styles.moreFocusedBtn)}
      >
        {intl.formatMessage(MSG.more, {
          num: savedSearches.length - numberOfSavedSearchesToDisplay,
        })}
        <Chevron className={styles.chevron} />
      </Button>
    )
  }

  return (
    <>
      <li
        role='option'
        id={result.id}
        key={result.id}
        onClick={handleClick}
        aria-selected={focused}
        onKeyDown={handleKeyDown}
        onTouchStart={() => handleOnTouchStart(type, index)}
        className={classnames(styles.root, focused && styles.focused)}
      >
        <Text weight='semibold' element='span'>
          {result?.displayName}
        </Text>
      </li>
      {!isLastResult && <hr className={styles.divider} />}
    </>
  )
}
